/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// refer to WhatsAppResponseMessageTextExport
export const whatsAppResponseTextMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("text"),
  body: z.string().nullable().optional(),
  include_url_preview: z.boolean().optional(),
});
